import {
  faSquare1,
  faSquare2,
  faSquare3,
  faSquare4,
  faSquare5,
} from '@fortawesome/pro-regular-svg-icons'

export const qAndAHelpData = {
  content: [
    {
      icon: faSquare1,
      question: 'What is Metering?',
      answer:
        'If your product (or, in the case of Microsoft, a specific plan of your product) has additional usage prices then usage metering is a mechanism to submit the usage data to Cloud marketplaces. Cloud marketplace then collates monthly data and bill respective customers.',
    },
    {
      icon: faSquare2,
      question: 'When are payments disbursed from metering submissions?',
      answer: `Disbursements from metering charges occur on the same schedule as regular marketplace payments.

      For AWS:
          Payments depend on the payment terms the buyer has with AWS. Most commonly these are Net 30 terms, but they can range from Net 60 to Net 90. According to AWS, “All usage is calculated monthly and billed monthly using the same mechanism as existing AWS Marketplace software.”

      For Microsoft:
          Payments are generally processed monthly. If a customer has non-standard payment terms, such as Net 45 or Net 60, the payout timeline will be extended accordingly. You can view the payment terms for an invoice in Revenue Insights, which shows the Invoice (Created) Date and the corresponding Due Date.`,
    },
    {
      icon: faSquare3,
      question: 'How will we know when and how much to meter our customers?',
      answer:
        'It is up to you to implement a process to facilitate the tracking of usage and regular submission of usage charges. As a best practice, usage charges should either be submitted regularly as they occur, or aggregated and submitted on a specific day of the month.',
    },
    {
      icon: faSquare4,
      question: 'How can the metering process be automated?',
      answer:
        'Labra provides an API for the submission of metering charges programmatically. More info ',
      link: 'https://docs.labra.io/reference/post_metering-metering-records',
      linkedText: 'here',
    },
    {
      icon: faSquare5,
      question:
        'How do we know our metering records have been submitted to the marketplace?',
      answer: `Look for a green checkmark next to the submitted usage in the Labra Platform. For submission failures, the UI will show a red x and indicate the reason for the failure.
If you are using the Metering API, you may also use the API or the webhook to confirm the status of the records.`,
    },
  ],
}
